<template>
  <div class="flex flex-wrap flex-row justify-between items-center px-8 py-8">
    <div class="logo-ma">
         <img :src="logo" width="200" height="130" >
      </div>
    <div class="flex flex-row flex-wrap justify-end items-center uppercase">
    <div class="label text-2xl p-4">{{labels[0]}}</div>
      <span
        class="toggle-wrapper"
        role="checkbox"
        tabindex="0"
        @click="toggle"
        @keydown.space.prevent="toggle"
      >

        <span
          class="toggle-background"
          :class="backgroundStyles"
        />
        <span
          class="toggle-indicator"
          :style="indicatorStyles" 
        />
      </span>
    <div class="label text-2xl p-4">{{labels[1]}}</div>
    </div>
  </div>
    <template v-if="!isToggle">
        <slot name="switch1"></slot>
    </template>
    <template v-else>
        <slot name="switch2"></slot>
    </template>
  </template>
  
<script>

export default {
  name:'switch-toggle',
  props: {
    labels:{
      type: Array,
      default:[]
    },
    logo:{
      type: String,
      default:'',
    }
  },
  data(){
    return{
     isToggle: false,
    }
  },
  computed: {
    backgroundStyles() {
      return {
        'gold-mid': this.isToggle,
        'gray-lighter': !this.isToggle
      };
    },
    indicatorStyles() {
      return { transform: this.isToggle ? 'translateX(14px)' : 'translateX(0)' };
    }
  },
  methods: {
    toggle() {
      this.isToggle = !this.isToggle;
    }
  }
};
</script>
<style lang="scss" scoped>
.gold-mid{
  background-color: #666666;
}

.gray-lighter{
  background-color: #c2c2c2;
}

.toggle-wrapper {
  display: inline-block;
  position: relative;
  cursor: pointer;
  width: 32px;
  height: 18px;
  border-radius: 9999px;
}

.toggle-wrapper:focus {
  outline: 0;
}

.toggle-background {
  display: inline-block;
  border-radius: 9999px;
  height: 100%;
  width: 100%;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color .4s ease;
}

.toggle-indicator {
  position: absolute;
  height: 14px;
  width: 14px;
  left: 2px;
  bottom: 2px;
  background-color: #ffffff;
  border-radius: 9999px;
  box-shadow:  0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform .4s ease;
}
</style>